import React from 'react';
import swal from 'sweetalert';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import shortid from 'shortid';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getBeneficiaryList } from './actions';
import { findField } from '../actions/common';

class BeneficiaryList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            list: [],
        };
        this.getBeneficiaryList = getBeneficiaryList.bind(this);
    }
    async componentWillMount() { //fetch list bene
        try {
            this.setState({ loading: true });
            const result = await this.getBeneficiaryList();
            console.log('benficeiry')
            console.log(result)
            this.setState({ loading: false, list: result.records || [] });
        } catch (error) {
            swal({
                text: error.toString(),
                title: 'An error when getting beneficiary records',
            });
        }
    }
    customFilter = (filter, row) => { //filter function for table
        const id = filter.pivotId || filter.id;
        if (row[id] !== null && typeof row[id] === "string") {
            return (row[id] !== undefined
                ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                : true);
        }
    }

    render() {
        const columns = [{
            Header: 'ID Number',
            accessor: 'Generated_From__r.ID_Number__c',
        }, {
            Header: 'ID Type',
            accessor: 'Generated_From__r.ID_Type__c',
            filterable: false,
        }, {
            id: 'FullName',
            Header: 'Full Name',
            accessor: a => a.Generated_From__r.Contact_Name__r.Name,
            // Cell: propsCol => propsCol.value.Name,
        }, {
            // Required because our accessor is not a string
            // accessor: 'Contact_Name__r',
            accessor: 'Generated_From__r.Contact_Name__r.Active__c',
            Header: 'Active Beneficiary',
            Cell: (propsCol) => {
                const { value } = propsCol;
                let isActive = false;
                if (value === 'true') {
                    isActive = true;
                }
                return <i className={`fa fa-2x fa-${isActive ? 'check' : 'times'}`} />;
            },
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={event => onChange(event.target.value)}
                    className="form-control"
                    value={filter ? filter.value : ''}
                >
                    <option value="">All</option>
                    <option value="true">Active</option>
                    <option value="false">Not Active</option>
                </select>
            ),
        }, {
            accessor: 'Generated_From__r.Contact_Name__r',
            Header: 'Last Payment',
            filterable: false,
            sortMethod: (a, b) => {
                let result = 0;
                const current = a.Last_Payment_Date__c === null ? '' : a.Last_Payment_Date__c;
                const next = b.Last_Payment_Date__c === null ? '' : b.Last_Payment_Date__c;

                if (current < next) result = -1;
                else if (current > next) result = 1;

                return result;
            },
            Cell: propsCol => (propsCol.value.Last_Payment_Date__c ? moment(propsCol.value.Last_Payment_Date__c).format('DD MMM YYYY') : '-'),
        }, {
            accessor: 'Generated_From__r.Nationality__c',
            Header: 'Nationality',
            Filter: ({ filter, onChange }) => {
                const fieldInfo = findField('Nationality__c', this.props.personObjectInfo);
                return (
                    <select
                        onChange={event => onChange(event.target.value)}
                        className="form-control"
                        value={filter ? filter.value : ''}
                    >
                        <option value="">All</option>
                        {fieldInfo.picklistValues ? fieldInfo.picklistValues.map(optionValue => (
                            <option key={shortid.generate()} value={optionValue.value}>{optionValue.label}</option>
                        )) : null}
                    </select>
                );
            },
        }, {
            accessor: 'Generated_From__r.Race__c',
            Header: 'Race',
            Filter: ({ filter, onChange }) => {
                const fieldInfo = findField('Race__c', this.props.personObjectInfo);
                return (
                    <select
                        onChange={event => onChange(event.target.value)}
                        className="form-control"
                        value={filter ? filter.value : ''}
                    >
                        <option value="">All</option>
                        {fieldInfo.picklistValues ? fieldInfo.picklistValues.map(optionValue => (
                            <option key={shortid.generate()} value={optionValue.value}>{optionValue.label}</option>
                        )) : null}
                    </select>
                );
            },
        }, {
            Header: 'Action',
            accessor: 'Generated_From__r.Id',
            filterable: false,
            Cell: props => (
                <span style={{ textAlign: 'center' }}>
                    <Link to={`/portal/beneficiary/${props.value}`} className="btn btn-sm btn-default"><i className="fa fa-eye" /> View</Link>
                </span>
            ),
        }];
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <h3>Beneficiary List</h3>
                        <p style={{ textAlign: 'center' }}>
                            {this.state.loading ? <i className="fa fa-3x fa-spinner fa-spin" /> : null}
                        </p>
                        <div className="content table-responsive table-full-width">
                            <ReactTable
                                data={this.state.list}
                                defaultFilterMethod={this.customFilter}
                                columns={columns}
                                filterable
                                defaultPageSize={10}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BeneficiaryList.propTypes = {
    personObjectInfo: PropTypes.array.isRequired,
};


const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
    personObjectInfo: state.objectInfo.Person__c,
});


export default connect(mapStateToProps, mapDispatchToProps)(BeneficiaryList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Beneficiary/BeneficiaryList.js
// module id = 796
// module chunks = 0